import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { useSelector } from 'hooks/redux'
import { getDashComponent, getVehicleSubType } from 'selectors/dash'
import { MSF, SWITCH } from '../../definitions/dashConstants'
import { TRUCK_SUBTYPE_42N } from 'utils/constants'
import {
  Part__Blank_2in_Gauge as BlankGauge,
  Part__Blank_42N_Switch as BlankSwitch42N,
  Part__Blank_43N_Switch as BlankSwitch,
  Part__Blank_Allison_Eaton_Shifter as BlankAEShifter,
  Part__Blank_Espar_Easy_Start as BlankEsparEasyStart,
  Part__Blank_MSF_42N as BlankMSF42N,
  Part__Blank_MSF_43N as BlankMSF,
} from 'components/SwitchAndGauge/parts-components'

const AE_SHIFTER = 'ALLISON-EATON SHIFTER'
const ESPAR_EASY_START = 'ESPAR EASY START OR 7 DAY TIMER'
const GAUGE = '2-INCH GAUGE'

export const StyledBlankRect = styled.div((props) => {
  const { width, height } = props

  return `
    width: ${width}px;
    height: ${height}px;
    background-color: rgba(7, 7, 15, 0.4);
    border: 2px solid #07070F;
    border-radius: 10px;
    `
})

/**
 * @typedef {object} Props
 * @property {string} location location
 * @property {React.CSSProperties} style style
 * @property {{ width: number, height: number }} dimensions dimensions
 */

/**
 * Dynamically load SVG from image url
 * @param {Props} props props
 * @returns {React.FC<Props>}
 */
const BlankPart = ({ dimensions, location, style }) => {
  const component = useSelector(getDashComponent, location)
  const vehicleSubType = useSelector(getVehicleSubType)

  const renderBlank = () => {
    switch (component.locationType) {
      case GAUGE:
        return <BlankGauge style={style} />
      case ESPAR_EASY_START:
        return <BlankEsparEasyStart style={style} />
      case AE_SHIFTER:
        return <BlankAEShifter style={style} />
      case MSF:
        return vehicleSubType === TRUCK_SUBTYPE_42N ? (
          <BlankMSF42N style={style} />
        ) : (
          <BlankMSF style={style} />
        )
      case SWITCH:
        return vehicleSubType === TRUCK_SUBTYPE_42N ? (
          <BlankSwitch42N style={style} />
        ) : (
          <BlankSwitch style={style} />
        )
      default:
        return (
          <StyledBlankRect
            width={dimensions.width}
            height={dimensions.height}
          />
        )
    }
  }

  return renderBlank()
}

BlankPart.propTypes = {
  location: PropTypes.string.isRequired,
  style: PropTypes.object,
  dimensions: PropTypes.shape({
    width: PropTypes.number,
    height: PropTypes.number,
  }),
}

export default BlankPart
